import { AlertConfiguration } from "./alertConfigurations"
import { LevelConfigurationItemMode } from "./levelConfiguration"
import { LevelSettingResponse } from "@/api/FacilityLevelsService"
import { SensorType } from "@/api/SensorsService"
import { CellStatus } from "@/components/CellCard"
import { DropdownOption } from "@/components/shared/Dropdown"
import { IconProps } from "@/components/shared/Icon"

export type LevelSettingForm = LevelSettingResponse

export enum MeasurementSystem {
   METRIC = "metric",
   IMPERIAL = "imperial",
}

export interface FacilityAddress {
   country: string
   state: string
   city: string
   zipCode: string
   street: string
   timezone: string | null
}

export interface FacilityAlerts {
   total: number
   stale: number
}

export interface Facility {
   id: string
   name: string
   address: FacilityAddress
   alerts: FacilityAlerts
   cells?: number
   wearables?: number
   users?: number
   entraTid: string
   entraSsoActive: boolean
   consentUrl?: string
}

export type FacilityForm = {
   id?: string
   name: string
   address?: FacilityAddress
   settings?: LevelSettingForm[]
   entraTid?: string
   entraSsoActive?: boolean
}

export interface FacilityLevelType {
   id: string
   name: string
   depth: number
   icon: string
   parent: string | null
   mode: LevelConfigurationItemMode
}

export interface FacilityLevelDropdown {
   typeId: string
   label: string
   activeValue: string
   options: DropdownOption[]
   disabled?: boolean
   icon: IconProps["name"]
}

export interface LevelType {
   id: string
   mode: LevelConfigurationItemMode
   name: string
   depth: number
   icon: string
   parent: string | null
}

export interface Sensor {
   id: string
   cellStatus?: CellStatus
   serialNumber?: string
   macAddress: string
   type?: SensorType
}

export type LevelAlertConfiguration = AlertConfiguration & {
   source: string | null
}

export type Level = {
   id: string
   name: string
   hasCustomConfigurations: boolean
   customIdentifier: string | null
   type: LevelType
   parents: string[]
   sensors: Sensor[]
   address: FacilityAddress | null
   alertConfigurations: LevelAlertConfiguration[]
   vacant: boolean
   maintenance: boolean
}

export interface FacilityDetails {
   id: string
   name: string
   address: FacilityAddress
   levelTypes: FacilityLevelType[]
   levels: Omit<Level, "alertConfigurations" | "vacant" | "maintenance">[]
   settings: LevelSettingResponse[]
   levelStructureLocked: boolean
}

export interface LevelForm {
   name: string
   parents: string[]
   type: string
   sensors: Omit<Sensor, "cellStatus">[]
   vacant: boolean
   maintenance: boolean
}

export interface FacilityLevelManagementItem {
   id: string
   name: string
   icon: IconProps["name"]
   parents: string[]
   children: FacilityLevelManagementItem[]
   type: LevelType
}

export interface FacilityLevelManagementItemForm {
   type: string
   name: string
   icon?: IconProps["name"]
   parents?: string[]
}
